module.exports = __webpack_public_path__ + "assets/user-profile-pic.8ea3997c076cd533a266d43a116167e8.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/user-profile-pic.png
// module id = 1057
// module chunks = 0